/** @format */
import React from 'react';
import Table from '@material-ui/core/Table';
import withStyles from '@material-ui/core/styles/withStyles';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import {TableCell, TableHead, TableRow} from "@material-ui/core";

function PaperedTable({...props}) {
    const {
        classes,
        className,
        children,
        plain,
        profile,
        blog,
        raised,
        background,
        pricing,
        color,
        product,
        testimonial,
        chart,
        login,
        beforeTableContent,
        ...rest
    } = props;


    return (
        <>
            {/*<div className={classes.tableRootNotMinWidth} style={{position: 'relative', overflow: 'auto'}}>*/}
            {/*    */}
            {/*</div>*/}
            <div className={classes.tableRootNotMinWidth}>
                <Table className={classes.tableRootNotMinWidth} {...rest}>
                    <TableHead className={classes.topLabelPadding}>
                        <TableRow>
                            <TableCell
                                className={classes.tableControlStickyHeader}
                                colSpan={3}
                            >
                                {beforeTableContent}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    {children}
                </Table>
            </div>
        </>
    );
}

export default withStyles(OplAppStyle)(PaperedTable);